module.exports = __webpack_public_path__ + "img/588-42dfb3.png";